import type { TransitionProps } from 'vue'
import type { RouteLocationNormalizedGeneric } from 'vue-router'
import { getPageType } from '@autobid/ui/composables/car/useCarPageInfo'

export function pageTransitionMiddleware(to: RouteLocationNormalizedGeneric, from: RouteLocationNormalizedGeneric, currentPageType: 'barometer' | 'details') {
  const prevPageType = from?.name ? getPageType(String(from.name)) : undefined
  const isPrevPageTheSameType
    = prevPageType
      && (prevPageType === currentPageType
        || (prevPageType === 'barometerCurrent' && currentPageType === 'barometer'))
  const isStillTheSameSubpage = to.path === from.path
  const toPageTransition = to.meta.pageTransition as TransitionProps | undefined | boolean

  if (
    isStillTheSameSubpage
    || !isPrevPageTheSameType
    || !toPageTransition
    || typeof toPageTransition === 'boolean'
  ) {
    to.meta.pageTransition = false
    return
  }

  const toggleOverflow = (type: 'add' | 'remove') => {
    const appWrapper = document.querySelector('.app-wrapper')
    appWrapper && appWrapper.classList[type]('overflow-x-hidden')
  }

  toPageTransition.name
    = to.query.pageType === 'prev'
      ? 'slide-right'
      : 'slide-left'

  toPageTransition.onBeforeLeave = () => toggleOverflow('add')
  toPageTransition.onAfterEnter = () => toggleOverflow('remove')
}
